import React, { useState, useEffect } from 'react';
// components
import Button from '../../Button';
import Modal from '../index';
// assets
import questionImg from 'img/question-img.svg';
//styles
import { Image, CustomImage, CustomButton, TextBtnYes } from "./styles";

interface IModalYesNo {
  text: string;
  setModalResponse?: any;
}

const ModalYesNo = ({ text, setModalResponse }: IModalYesNo) => {
  const [action, setAction] = useState('');

  useEffect(() => {
    setModalResponse(action);
  }, [action, setModalResponse]);

  return (
    <Modal width={"350px"} alignButtons={"center"} gap={"20px"}>
      <Image>
        <CustomImage src={questionImg} alt="alert icon" />
      </Image>

      <div className="message">{text}</div>

      <div className="buttons">
        <CustomButton className="btnNo">
          <Button second label="Não" onClick={() => setAction('no')} />
        </CustomButton>

        <CustomButton className="btnYes">
          <Button 
            second 
            label={<TextBtnYes>Sim</TextBtnYes>} 
            onClick={() => setAction('yes')} 
            className='bg-greenDarkViveo'
          />
        </CustomButton>
      </div>
    </Modal>
  );
};

export default ModalYesNo;
